import type { QuestionnaireStore } from "../Store";

import QuestionnaireApiConnector from "@/Services/TherapyApi/Questionnaires";
import QuestionnaireApiToQuestionnaireTransformer from "@/Modules/Transformers/Questionaire/QuestionnaireApiToQuestionnaire";

import { danger } from "@/Utils/Debug";

class FetchQuestionnaireActionHandler {
  constructor(
    private readonly questionnaireStore: QuestionnaireStore,
    private readonly questionnaireApiConnector = new QuestionnaireApiConnector(),
    private readonly questionnaireApiToQuestionnaireTransformer = new QuestionnaireApiToQuestionnaireTransformer()
  ) {}

  public async handle(questionnaireId: string): Promise<void> {
    this.questionnaireApiConnector
      .getById(questionnaireId)
      .then((questionnaireApiResponse) => {
        const questionnaire =
          this.questionnaireApiToQuestionnaireTransformer.transform(questionnaireApiResponse);

        const isQuestionnaireExists = !this.questionnaireStore.questionnaires.some(
          (questionnaire) => questionnaire.id === questionnaireId
        );

        if (isQuestionnaireExists) {
          this.questionnaireStore.questionnaires.push(questionnaire);
        }
      })
      .catch(danger);
  }
}

export default FetchQuestionnaireActionHandler;
